$(function () {
  $('.searchByTag').click(function(e) {
    e.preventDefault();
    window.location.href = '/collections/all/' + encodeURIComponent(this.textContent);
  });
  if( window.innerWidth < 897){
    $("#main .news h2").click(function(){
      $(this).toggleClass("on").next().stop().slideToggle(300);
    });
    $("#main .spBox .spTtl").click(function(){
      $(this).toggleClass("on").next().stop().slideToggle(300);
    });
  }
  handleEventList();
  if(window.innerWidth < 897){
    $('#main .comPhotoUl').slick({
      dots: false,
      infinite: true,
      arrows: false,
      autoplay: true,
      centerMode: false,
      variableWidth: true,
      centerPadding: '0',
    }); 
  }
  $('.add-to-cart').click(function(e){
    e.preventDefault();
    var id = $(this).attr("data-id");
    callAjaxAddCart(id, 1);
  });

  $('.add-cart-with-quantity').click(function(e){
    e.preventDefault();
    var id = $(this).attr("data-id");
    var quantity = $('#quantity-' + id).val();
    if (quantity === "" || typeof quantity === "undefined" || quantity == 0) {
      swal({
        title: "エラー",
        text: "数量が無効です",
        icon: "error",
      });
    } else {
      callAjaxAddCart(id, parseInt(quantity));
    }
  });

  function callAjaxAddCart(id, quantity)
  {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {"id": id, "quantity": quantity},
      dataType: 'json',
      success: function(data) {
        var currentItemCount = $("#countCartItem").html();
        $(".cart-item").html(parseInt(currentItemCount) + quantity);
        $("#countCartItemSp").html(parseInt(currentItemCount) + quantity);
        window.scrollTo({top: 0, behavior: 'smooth'});
        $(".noti-cart").html('');
        $(".noti-cart").html('<p style="font-size: 14px;margin-top: 5px;color: #02a464;">カートに商品が追加されました</p>');
        swal({
          title: "Thank you!",
          text: "この商品をカートに入れました。",
          icon: "success",
        });
      },
      statusCode: {
        422: function() {
          swal({
            title: "エラー",
            text: "数量が足りません",
            icon: "error",
          });
        }
      }
    });
  }

  $('.need-login').click(function(e){
    e.preventDefault();
    swal({
      title: "エラー",
      text: "続行するにはログインしてください",
      icon: "info",
    });
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
});